define('lib/backbone/Backbone.PodioPaginatedView',['require','underscore','jquery','lib/backbone/Backbone.PodioView','jst!shared/paging-nav'],function (require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var jstPagingNav = require('jst!shared/paging-nav');

  return ViewPodioBase.extend({

    initializePagination: function(pages, urlFunction) {
      _.bindAll(this, 'renderPagingNav');

      this.elmPagingNav = this.elmPagingNav || $('.paging-nav');
      this.pagesInNavigation = pages || 9;  // use an odd number
      this.urlFunction = urlFunction;

      this.collection.bind('reset', this.renderPagingNav);
    },

    calculateDisplayValues: function() {
      var pageCount = this.collection.pagesAmount;
      var pageNumber = this.collection.currentPage;
      var middle = Math.floor(this.pagesInNavigation / 2);

      this.startPoint = 1;
      this.endPoint = this.pagesInNavigation;

      if (pageNumber > middle) {
        this.startPoint = pageNumber - middle;
        this.endPoint = pageNumber + middle;
      }

      if (this.endPoint > pageCount) {
        this.startPoint = pageCount - this.pagesInNavigation - 1;
        this.endPoint = pageCount;
      }

      if (this.startPoint < 1) {
        this.startPoint = 1;
      }
    },

    renderPagingNav: function() {
      this.calculateDisplayValues();
      this.elmPagingNav.html(jstPagingNav({
        isFirst: this.collection.isFirstPage(),
        isLast: this.collection.isLastPage(),
        currentPage: this.collection.currentPage,
        startPoint: this.startPoint,
        endPoint: this.endPoint,
        lastPage: this.collection.pagesAmount,
        urlFunction: this.urlFunction
      }));
    }
  });

});

